import React, { memo } from "react";
import { Typography, TextField } from "@mui/material";
import { ContactInfoFormProps } from "./types";

const ContactInfoForm: React.FC<ContactInfoFormProps> = memo(
  ({
    title,
    existingInfo,
    existingTemplate,
    missingMessage,
    label,
    error,
    errorMessage,
    value,
    onChange,
  }) => (
    <>
      <Typography variant="h4" gutterBottom>
        {title}
      </Typography>
      {existingInfo ? (
        <Typography
          color="text.secondary"
          variant="body2"
          gutterBottom
          mb={2.5}
        >
          {existingTemplate.replace(/\{(phone|email)\}/, existingInfo)}
        </Typography>
      ) : (
        <Typography color="text.secondary" variant="body2" gutterBottom>
          {missingMessage}
        </Typography>
      )}
      <TextField
        label={label}
        variant="outlined"
        fullWidth
        value={value}
        onChange={onChange}
        error={error}
        helperText={error ? errorMessage : ""}
      />
    </>
  )
);

export default ContactInfoForm;
